import { useState, useEffect, useCallback } from "react";
import {
    collection,
    addDoc,
    query,
    orderBy,
    onSnapshot,
    serverTimestamp,
} from "firebase/firestore";
import { db } from "../firebase";

const useProductReviews = (productId) => {
    const [reviews, setReviews] = useState([]);
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        if (productId == null) return;
        setLoading(true);
        const reviewsRef = collection(db, "products", String(productId), "reviews");
        const reviewsQuery = query(reviewsRef, orderBy("createdAt", "desc"));
        const unsubscribe = onSnapshot(reviewsQuery, (snapshot) => {
            setReviews(snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
            setLoading(false);
        });
        return unsubscribe;
    }, [productId]);

    const addReview = useCallback(async ({ name, rating, comment }) => {
        setSubmitting(true);
        try {
            const reviewsRef = collection(db, "products", String(productId), "reviews");
            await addDoc(reviewsRef, {
                name: name.trim(),
                rating,
                comment: comment.trim(),
                createdAt: serverTimestamp(),
            });
        } finally {
            setSubmitting(false);
        }
    }, [productId]);

    const reviewCount = reviews.length;
    const averageRating = reviewCount > 0
        ? reviews.reduce((sum, r) => sum + r.rating, 0) / reviewCount
        : 0;

    return { reviews, loading, submitting, addReview, averageRating, reviewCount };
};

export default useProductReviews;
